export default __webpack_public_path__ + "static/media/icon_menu_okara.ee995019.svg";